import { IApplicationState } from 'shared/types/redux';

export const selectUserPhones = (state: IApplicationState) => {
  return state.user.phones;
};
